import React, { useEffect, useState } from 'react';
import '../styles/Playlist.scss';
import Modal from 'react-bootstrap/Modal';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import FeaturedPlayListForm from '../playlist/featured-playlist/FeaturedPlayListForm';
import PersonalPlayListForm from '../playlist/personal-playlist/PersonalPlayListForm';
import allVideoTime from '../../hook/useAllVideoTime';
import StudioPlayListForm from '../playlist/studio-playlist/StudioPlayListForm';
import { useAtomValue } from 'jotai';
import { userInfoAtom } from '../../data/atoms/utilsAtoms';
import { generatePlayerPageViewUrl, generateTypeOfContentView } from '../../utils/generatePlayerPageViewUrl';
import './style.css'
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { Playlist } from '../../constants/Playlist';
import { Users } from '../../constants/Users';
import { sortVideosByPosition } from '../../utils/sortVideos';
import { buildRoutes } from '@/service/buildRoutes';


export function AllPlayList({
	title = '',
	data,
	nshowModal,
	setnModalShow,
	page = '',
	currentIndex,
	setCurrentIndex,
	playlistType = null,
	handleModalSubmit = () => { },
	subscribtionStatus,
	isEditMode,
	onDelete
}) {
	const [show, setShow] = useState(false);
	const [playlist_type, setPlayListType] = useState(playlistType);

	const handleClose = () => {
		setShow(false);
		handleModalSubmit();
	};
	const handleShow = () => setShow(true);

	const location = useLocation();
	const path = location.pathname;
	console.log("Subscription Status", subscribtionStatus)

	useEffect(() => {
		if (playlistType !== null) return;
		if (path === '/personal-playlist') {
			setPlayListType(Playlist.personalPlaylist);
		} else if (path === '/featured-playlist') {
			setPlayListType(Playlist.featuredPlaylist);
		} else if (path === '/studio-playlist') {
			setPlayListType(Playlist.studioPlaylist);
		} else {
			setPlayListType(Playlist.ALL);
		}
	}, [path, playlistType]);

	const userInfo = useAtomValue(userInfoAtom);
	const navigate = useNavigate();

	const playAll = item => {
		if (!subscribtionStatus) {
			navigate(buildRoutes.toPlans());
			return;
		}
		const typeOfContentView = generateTypeOfContentView(item?.type);
		const url = generatePlayerPageViewUrl(item.videos[0]?._id, typeOfContentView, item._id);
		navigate(url);
	};

	const getTotalDuration = (videos = []) =>
		videos
			.map(v => Number(v?.duration))
			.filter(d => !Number.isNaN(d))
			.reduce((acc, d) => acc + d, 0);

	return (
		<>
			<div
				className={`c-tab_cata-text update ${playlist_type === Playlist.featuredPlaylist || userInfo?.role === Users.admin ? 'remove__mt' : ''
					}`}
			>
				<div className="c-featured_box-left-b4">
					{playlist_type === Playlist.featuredPlaylist && userInfo?.role === Users.admin ? (
						<Link onClick={handleShow} href="#" className="outline__primary__btn">
							+ <span className="d-none d-sm-inline">add new</span>{' '}
						</Link>
					) : (
						''
					)}
					{playlist_type === Playlist.personalPlaylist && (
						<Link onClick={handleShow} href="#" className="outline__primary__btn">
							+ <span className="d-none d-sm-inline">add new</span>{' '}
						</Link>
					)}
					{playlist_type === Playlist.studioPlaylist && userInfo?.user?.userType && (
						<Link onClick={handleShow} href="#" className="outline__primary__btn">
							+ <span className="d-none d-sm-inline">add new</span>{' '}
						</Link>
					)}
					{userInfo && playlist_type === Playlist.ALL && (
						<Link onClick={handleShow} href="#" className="outline__primary__btn">
							+ <span className="d-none d-sm-inline">add new</span>{' '}
						</Link>
					)}
				</div>
				<h4>{page}</h4>
			</div>

			<div className="c-video_feature-box update scroller">
				<div className=" c-video_textcol p-0 title__box">
					<h4 className="d-none d-lg-block text-blue">
						{path === '/all-playlist' ? (
							<span className={''}>ALL Playlists</span>
						) : (
							<Link to="/all-playlist" className={title !== '' ? 'text-71717A' : ''}>
								ALL Playlists
							</Link>
						)}

						{title !== '' && <span className="text-71717A"> &gt; </span>}
						{title !== '' && <span>{title}</span>}
					</h4>
					<h4 className="playlist-mobile d-sm-none">Playlists</h4>
				</div>

				<div className="overflow-x-auto pb-1" style={{ scrollbarWidth: 'thin' }}>
					<div className="d-flex gap-1 gap-sm-2 grid__row">
						{data?.map((item, index) => {
							return (
								<div key={index} className="d-flex playlist__item" onClick={() => setCurrentIndex(index)}>
									<div className={`playlist__card w-100 ${index === currentIndex ? 'active' : null}`}>
										<div className="d-flex flex-col d-sm-block mb-1 mb-sm-0 res__info__box">
											<div className="thumb__box position-relative">
												<img
													src={item?.thumbnailLink || sortVideosByPosition( item?.videos)[0]?.thumnailLink}
													alt="Video Thumbnail"
													className="thumbnail"
												/>
												{/* <img
													src="https://i.vimeocdn.com/video/1741403504-f2f5df20c07178f421da06e163239ea1a5465bb2b077ed021ab231a91af82050-d"
													alt="Video Thumbnail"
													className="img-fluid thumbnail"
												/>
												<img
													src="https://i.vimeocdn.com/video/1741403504-f2f5df20c07178f421da06e163239ea1a5465bb2b077ed021ab231a91af82050-d"
													alt="Video Thumbnail"
													className="img-fluid thumbnail"
												/>
												<img
													src="https://i.vimeocdn.com/video/1741403504-f2f5df20c07178f421da06e163239ea1a5465bb2b077ed021ab231a91af82050-d"
													alt="Video Thumbnail"
													className="img-fluid thumbnail"
												/> */}
											</div>
											{/* <span className="duration">{item.duration}</span> */}
											<div className="info__height">
												<div className="d-flex flex-row justify-content-between">
													<span className="duration d-none d-sm-block">
														{Array.isArray(item?.videos) && item?.videos?.length > 0
															&& allVideoTime(
																getTotalDuration(item.videos)
															)}
													</span>
													{item.type !== Playlist.FPL && isEditMode && (
														<DeleteOutlineIcon style={{ color: '#3cb4e4' }} onClick={(e) => onDelete(e, item)} />
													)}

												</div>
												<h2 className="title">{item.name}</h2>
												{item.type === Playlist.PPL && <p className="list_name mb-0">Personal Playlist</p>}
												{item.type === Playlist.FPL && <p className="list_name mb-0">Featured Playlist</p>}
												{item.type === Playlist.SPL && <p className="list_name mb-0">Studio Playlist</p>}
												{!item.type && <p className="list_name mb-0">{item.description}</p>}
												<p className="count">{item.videos?.length} Videos</p>
											</div>
										</div>
										<div className="text-center d-flex d-sm-block justify-content-between align-items-center ">
											<span className="duration d-sm-none m-0">
												{item?.videos && Array.isArray(item?.videos) && item?.videos?.length > 0
													? allVideoTime(
														getTotalDuration(item.videos)
													)
													: ''}
											</span>
											<button
												className="outline__primary__btn text-uppercase d-inline-flex align-items-center rounded-3"
												onClick={() => playAll(item)}
											>
												<span>Play All</span>
												<i className="fa fa-play"></i>
											</button>
										</div>
									</div>
								</div>
							);
						})}
						{playlist_type === Playlist.featuredPlaylist && userInfo?.role === Users.admin ? (
							<div className="d-flex playlist__item">
								<div onClick={handleShow} className="add__card w-100 d-flex justify-content-center align-items-center">
									<i className="fa fa-plus"></i>
								</div>
							</div>
						) : (
							''
						)}
						{playlist_type === Playlist.personalPlaylist && (
							<div className="d-flex playlist__item">
								<div onClick={handleShow} className="add__card w-100 d-flex justify-content-center align-items-center">
									<i className="fa fa-plus"></i>
								</div>
							</div>
						)}
						{playlist_type === Playlist.studioPlaylist && userInfo?.user?.userType && (
							<div className="d-flex playlist__item">
								<div onClick={handleShow} className="add__card w-100 d-flex justify-content-center align-items-center">
									<i className="fa fa-plus"></i>
								</div>
							</div>
						)}
						{userInfo && playlist_type === Playlist.ALL && (
							<div className="d-flex playlist__item">
								<div onClick={handleShow} className="add__card w-100 d-flex justify-content-center align-items-center">
									<i className="fa fa-plus"></i>
								</div>
							</div>
						)}
						{/* <div className="d-flex" style={{ width: "223px", minWidth: '223px' }}>
                            <div onClick={handleShow} className="add__card w-100 d-flex justify-content-center align-items-center">
                                <i className="fa fa-plus"></i>
                            </div>
                        </div> */}
					</div>
					{/* row */}
				</div>
			</div>

			<Modal show={show} onHide={handleClose} className="add__modal">
				<Modal.Header closeButton>
					<Modal.Title>Add New Playlist</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					{playlist_type === Playlist.personalPlaylist && (
						<PersonalPlayListForm
							handleClose={handleModalSubmit}
							show={show}
							setShow={setShow}
							nshowModal={nshowModal}
							setnModalShow={setnModalShow}
							handleModalSubmit={handleModalSubmit}
						/>
					)}
					{playlist_type === Playlist.featuredPlaylist && <FeaturedPlayListForm show={show} setShow={setShow} />}
					{playlist_type === Playlist.studioPlaylist && userInfo?.user?.userType && (
						<StudioPlayListForm setShow={setShow} setnModalShow={setnModalShow} />
					)}
					{playlist_type === Playlist.ALL && (
						<PersonalPlayListForm
							show={show}
							setShow={setShow}
							nshowModal={nshowModal}
							setnModalShow={setnModalShow}
							handleModalSubmit={handleModalSubmit}
							handleClose={handleModalSubmit}
						/>
					)}
				</Modal.Body>
			</Modal>
		</>
	);
}
